export default __webpack_public_path__ + "img/dbdee7ddd23e476e80c0efdd87de5b78.png";